import React, { Component } from 'react';


import NumberFormat from 'react-number-format';
import {transactionID, clientInfo} from '../../../services/helpers';
import axios from 'axios';
import Swal from 'sweetalert2';

import ImageMakeNewRecharge from '../images/recharge-make-new-recharge.png';



class ChooseNumber extends Component {

    constructor(props) {
        super(props);

        axios.defaults.headers.common['Authorization'] = "Bearer " + clientInfo().accessToken;
        axios.defaults.headers.common['Content-Type'] = "application/json";

        this.state = {
            homeHistory: [],
            bundleInfo: [],
            chooseNewNumber: false,
            newNumber: ''
        }
    }

    getBundleInfo = async () => {
        this.props.setLoading(1);

        const bundleInfo = await axios.post('https://www.pagtel.com.br/Hub360Correios/v2/BundleInfo', {
            transactionId: transactionID('ACG'),
            msisdn: clientInfo().number
        });

        this.props.setLoading(0);
        this.setState({bundleInfo: bundleInfo.data});
    }

    getHomeHistory = async () => {

        this.props.setLoading(1);
        const homeHistory = await axios.post('https://www.pagtel.com.br/Hub360Correios/v2/homeHistory', {
            transactionId: transactionID('ACH'),
            msisdn: clientInfo().number
        })
        
        this.props.setLoading(0);
        this.setState({ homeHistory: homeHistory.data.infoDetails })
    }

    handleNumber = (number) => {
        this.props.setNumber(number);
        this.props.step(2);
    }

    componentDidMount = async () => {

        await this.getBundleInfo();
        await this.getHomeHistory();

    }

    render() {

        const {homeHistory, bundleInfo, chooseNewNumber, newNumber} = this.state;

        return (

            <div className="choose-number-container" >
                <h2>Qual número você deseja carregar?</h2>
                <div>
                    <ul className="choose-number-box-white">
                        {
                            !chooseNewNumber && 
                        
                        <li>
                            <h1>Meu número</h1>
                            <small>{clientInfo().number}</small>

                            <p className="choose-number-plan">{bundleInfo.bundleName}</p>

                            <div className="choose-number-plan-container">
                                {
                                    homeHistory.map((response, key) => {

                                        let output;

                                        switch (response.type) {
                                            case 'VOICE':
                                                output = <div className="choose-number-plan-item" key={key}>
                                                            <h5><i className="choose-number-plan-icon bg-color-info"></i>TELEFONE</h5>
                                                            <p><strong>{response.details.used}M</strong> de {response.details.total}m</p>
                                                        </div>;
                                                break;
                                            case 'SMS':
                                                output = <div className="choose-number-plan-item" key={key}>
                                                    <h5><i className="choose-number-plan-icon bg-color-success"></i>SMS</h5>
                                                    <p><strong>{response.details.used}</strong> de {response.details.total}</p>
                                                </div>;
                                                break;
                                            case 'DATA':
                                                output = <div className="choose-number-plan-item" key={key}>
                                                    <h5><i className="choose-number-plan-icon bg-color-danger"></i>INTERNET</h5>
                                                    <p><strong>{response.details.used}GB</strong> de {response.details.total}GB</p>
                                                </div>;
                                                break;
                                        }
                                        return (output);
                                    }
                                    )
                                }
                             
                            </div>
                            <div className="arrow-icon" href="#" onClick={() => { this.handleNumber(clientInfo().number); }}></div>
                        </li>
                        }

                        {
                            chooseNewNumber && 
                            <li>
                                <h1>Outro Número</h1>
                                <NumberFormat
                                    format="(##) #####-####"
                                    placeholder="(11) 99999-9999"
                                    className="choose-another-number-input"
                                    onValueChange={(values) => {
                                        const { value } = values;
                                        this.setState({
                                            newNumber: '55' + value
                                        });
                                    }}
                                />

                                <div className="arrow-icon" href="#" onClick={() => {
                                    if (newNumber === 0 || newNumber.length < 13) {
                                            Swal.fire({
                                                title: 'Erro!',
                                                text: "Digite corretamente o número para recarregar!",
                                                type: 'error'
                                            })
                                            return false;
                                        }
                                        this.handleNumber(newNumber)
                                    }}>
                                </div>
                            </li>
                        }
                        
                    </ul>

                    {
                        !chooseNewNumber && 
                        <p className="choose-number-new-number btn-choose-another-number" onClick={() => { this.setState({chooseNewNumber: true}) }}>Recarregar outro número</p>
                    }
                    

                   
                </div>
            </div>
            
        );
    }

}

export default ChooseNumber